import { ErroApi } from './api';

/** No máximo três tentativas, apenas para indisponibilidade transitória ou rede. */
export function repetirQuery(falhas: number, erro: unknown): boolean {
  return falhas < 2 && erro instanceof ErroApi && erro.causa !== 'tempo_esgotado' && (
    (erro.status === 503 && erro.code === 'servico_indisponivel') ||
    (erro.status === 0 && erro.code === 'rede')
  );
}

export function esperaQuery(tentativa: number, erro?: unknown): number {
  const base = tentativa === 0 ? 250 : 750;
  const espera = base + Math.random() * 100;
  return erro instanceof ErroApi && erro.status === 503 && erro.code === 'servico_indisponivel' && erro.retryAfter !== undefined
    ? Math.max(espera, Math.min(5_000, erro.retryAfter * 1_000)) : espera;
}

export const opcoesQueries = {
  refetchOnWindowFocus: false,
  retry: repetirQuery,
  retryDelay: esperaQuery,
};
